import { StyleSheet } from 'react-native';
import { MBButton, MBClearButton } from '@shared/components/MBButton';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Subform } from '@shared/data/entity/fields/SubformField';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { countCompletedSubformFields } from './hooks';

interface Props {
  subform: Subform;
  onSelect: (workflowTemplateId: string) => void;
  onClear: VoidFunction;
  isReadOnly?: boolean;
}

export function SubformContent({ subform, onSelect, onClear, isReadOnly }: Props) {
  const { workflowTemplate } = useWorkflowTemplate(subform.workflowTemplateId);
  const completedFields = countCompletedSubformFields(
    workflowTemplate?.components ?? [],
    subform.data,
  );

  return (
    <View fill>
      <MBTouchableOpacity onPress={() => onSelect(subform.workflowTemplateId)}>
        {!isReadOnly && (
          <MBView style={styles.clearButton}>
            <MBClearButton onPress={onClear} />
          </MBView>
        )}
        <MBView flex style={styles.cardContainer}>
          <View>
            <Text size="body1" weight="semibold">
              {workflowTemplate?.name}
            </Text>
            <View paddingTop={0.5}>
              <Text size="body2">
                {i18n('card.blocks.subformsInput.fieldsCompleted', { count: completedFields })}
              </Text>
            </View>
          </View>
          {!isReadOnly && (
            <View paddingTop={1.5} row={true} marginLeft={-0.5}>
              <MBButton
                title={i18n('card.blocks.subformsInput.start')}
                onPress={() => onSelect(subform.workflowTemplateId)}
                style={{ paddingHorizontal: grid(3) }}
                size={'small'}
              />
            </View>
          )}
        </MBView>
      </MBTouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    margin: -1, // cheat into box border so padded content aligns with field label
    paddingTop: grid(1.5),
    paddingBottom: grid(1.5),
    paddingHorizontal: grid(2),
  },
  clearButton: {
    position: 'absolute',
    top: grid(0.5),
    right: grid(0.5),
    zIndex: 1,
  },
});
